import React, { useState, useEffect } from "react";
import "../css/Nav.css";
import logo from "../images/logo.svg";

// Иконки Bootstrap
import { 
  House, 
  InfoCircle, 
  PlayCircle, 
  Rocket, 
  List,
  X,
  ArrowRight
} from "react-bootstrap-icons";

export const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className={`box _nav ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        {/* Логотип */}
        <div className="nav-logo">
          {/* Старый логотип */}
          <img src={logo} alt="Logo" className="nav-logo-img" />
          
          {/* Новый SVG логотип */}
          <svg 
            viewBox="0 0 64 64" 
            className="nav-logo-svg"
            role="img" 
            aria-label="TheCryptoHub" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient id="chOrbitStroke" x1="0" y1="1" x2="1" y2="0">
                <stop offset="0%" stopColor="#16A34A" />
                <stop offset="55%" stopColor="#22C55E" />
                <stop offset="100%" stopColor="#4ADE80" />
              </linearGradient>
              <linearGradient id="chOrbitSpark" x1="0" y1="1" x2="1" y2="0">
                <stop offset="0%" stopColor="#22C55E" />
                <stop offset="100%" stopColor="#4ADE80" />
              </linearGradient>
            </defs>
            <path 
              d="M45.5 18.5 A18 18 0 1 0 49 34" 
              stroke="url(#chOrbitStroke)" 
              strokeWidth="6" 
              strokeLinecap="round"
            />
            <path 
              d="M22 42 L33 33 L47 19" 
              stroke="url(#chOrbitSpark)" 
              strokeWidth="6" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
            <circle cx="47" cy="19" r="6" fill="#4ADE80" />
          </svg>
          
        </div>

        {/* Бургер-меню (мобилка) */}
        <button className="burger-menu" onClick={toggleMenu} aria-label="Toggle menu">
          {isMenuOpen ? <X size={28} /> : <List size={28} />}
        </button>

        {/* Навигационные ссылки */}
        <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <li>
            <a href="#main" onClick={closeMenu}>
              <House size={18} />
              <span>Main</span>
            </a>
          </li>
          <li>
            <a href="#info" onClick={closeMenu}>
              <InfoCircle size={18} />
              <span>Instructions</span>
            </a>
          </li>
          <li>
            <a href="#live" onClick={closeMenu}>
              <PlayCircle size={18} />
              <span>Live</span>
            </a>
          </li>
        </ul>

        {/* Кнопка Participate (только десктоп) */}
        <a className="btn btn-desktop" href="#participate">
          <Rocket size={18} />
          <span>Participate</span>
          <ArrowRight size={16} />
        </a>
      </div>
    </nav>
  );
};